<template>
    <div class="px-6 py-5 overflow-y-auto right-content-grid-vs h-[calc(100vh-309px)]">
        <div class="text-[#414141] font-sans">
            <h3 class="text-[1.25rem] leading-[1.75rem] mb-[1rem] font-semibold">Fundraising Resources Overview</h3>
            <p class="text-[14px] leading-[22px] mb-[0.5rem]">
                Fundraising collateral is the collection of materials and messaging that clearly articulate your organization's mission, impact, and funding needs. These materials serve as the foundation for all donor communications—from grant proposals to major gift conversations. This module will help you clarify the key elements of your fundraising narrative and organize the assets needed to communicate effectively with funders and supporters.
            </p>
        </div>
    </div>
</template>

<script setup>
import { useStepValidation } from '@/composables/useStepValidation';

// Use the validation composable with default settings
useStepValidation();
</script>

<style scoped>
</style> 